module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2017/february-854dadc3a805035400abbeaab5fbb9d1.png";